import React, { useContext, useState } from "react";
import { Parallax } from "react-parallax";
import { Link } from "react-router-dom";
import { AppContext } from "../main";

const Section = (props) => {
  const { handleEditItem } = props;

  const { appState, setAppState } = useContext(AppContext);
  const { about = {}, editMode = false } = appState;

  if (!about?.title) {
    return null;
  }

  return (
    <div className="container position-relative">
      <div className="row">
        <div className="col-lg-12">
          <Parallax className="p-0" bgImage={about?.image} strength={300}>
            <div className="padding60 sm-padding40 sm-p-2 position-relative">
              <div className="row z-1">
                <div className="col-lg-6">
                  <h3 className="subtitle mb-3">{about.header}</h3>
                  <h2 className="wow fadeInUp" data-wow-delay=".2s">
                    {about?.subtitle}
                  </h2>
                  <p className="wow fadeInUp">
                    {about.title}
                    <br />
                    {about?.contactUs}{" "}
                    <a href={`tel:${about.phone.replace(/\D/g, "")}`}>
                      {about.phone}
                    </a>{" "}
                    {about.emailMessage}{" "}
                    <a href={`mailto:${about.email}`}>{about.email}</a>.
                    {about.message}
                  </p>
                  <div className="spacer-10"></div>
                  <Link className="btn-main mb-10" to={about?.button?.link || `/`}
                    onClick={() => {
                      setAppState((existing) => {
                        return {
                          ...existing,
                          showServices: true,
                        };
                      });
                    }} >
                    {about?.button?.title}
                  </Link>
                </div>
              </div>
            </div>
          </Parallax>
          {/* {about.img && <img
            src={about.img}
            className="sm-hide position-absolute avatar px-2"
            alt="User Avatar"
          />} */}
        </div>
      </div>
    </div>
  );
};

export default Section;
